"use client";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "~/components/Link";
import { normalizeCategoryForUrl } from "~/lib/lyrics.shared";
import getTagPalette from './VersuriKeywordIcons';

interface VersuriBreadcrumbsProps {
  categories?: string[] | null;
}

export default function VersuriBreadcrumbs({ categories }: VersuriBreadcrumbsProps) {
  const breadcrumbCategory =
    categories?.map((c) => c.trim()).filter(Boolean)[0];
  let IconComponent = null;
  if (breadcrumbCategory) {
    const breadcrumbIcon = getTagPalette('category', breadcrumbCategory);
    if (breadcrumbIcon) {
      IconComponent = breadcrumbIcon.icon;
    }
  }

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" sx={{ color: "text.secondary" }} />}
      aria-label="breadcrumb"
      sx={{ mb: 1 }}
    >
      <Link
        href="/versuri"
        effect="color-on-hover"
      >
        Versuri
      </Link>
      {breadcrumbCategory ? (
        <Link
          href={`/versuri/categorii/${normalizeCategoryForUrl(breadcrumbCategory)}`}
          effect="color-on-hover"
        >
          {IconComponent ? <IconComponent sx={{ mr: 0.5, fontSize: ".9rem" }} /> : null}
          {breadcrumbCategory}
        </Link>
      ) : null}
    </Breadcrumbs>
  );
}
